    <div class="modal-wrapper">
        <form #f="ngForm" (submit)='onSubmit(f)' novalidate>
            <div class="modal-header">
                <div class="modal-header-content">
                    <!-- TODO: controllare che nella creazione di una nuova esecuzione l'immagine si veda da qualsasi pagina si stia aprendo la modal -->
                    <img *ngIf="!data?.entityName && data?.selector !== 'scenario'" class='ws-img'
                         [src]="getIcon(data?.type, data?.toolName)" [alt]="data?.type">
                    <div class="d-flex flex-column">
                        <h4 class="modal-title">Nuova esecuzione</h4>
                        <p class="pnrr-dashboard">
                            <span class="mr-4" (click)="onOpenDashboard()">Apri dashboard</span>
                            <span class="ml-4" *ngIf="user_role == 'admin_ey'" (click)="onCreateTemplate()">Crea Template</span>
                        </p>
                    </div>
                </div>
                <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
            </div>
            <div class="modal-body">
                <app-shared-with *ngIf='data?.selector === "share" && data?.sharedWith.length' big title='Already shared with:'
                                 [sharedWithList]="data?.sharedWith"></app-shared-with>
                <div class="form-container">
                    <div class="form-group" *ngIf=' data?.selector !== "share" '>
                        <label for='name' class="input-title" [class.text-error]="f.controls?.name?.invalid && submitted">
                            Nome
                        </label>
                        <input name="name" required [(ngModel)]="name" class="form-control" type="text"
                               placeholder="La mia nuova pratica"
                               ngbAutofocus [class.is-invalid]="f.controls?.name?.invalid && submitted">
                        <small class="invalid-feedback text-error">Il nome è obbligatorio. Per favore compila questo campo</small>
                    </div>
                    <!--
                        <div class="form-group" *ngIf=' data?.selector === "execution" '>
                      <label for='companyName' class="input-title"
                        [class.text-error]="f.controls?.companyName?.invalid && submitted">
                        Company name
                      </label>
                      <input name="companyName" [(ngModel)]="companyName" required class="form-control" type="text"
                        placeholder="Insert Company name" [class.is-invalid]="f.controls?.companyName?.invalid && submitted">
                      <small class="invalid-feedback text-error">Company name is mandatory. Please fill the field!</small>
                    </div>

                        -->
                    <div class="form-group" *ngIf='data?.collaborators'>
                        <!-- TODO: quando si apre la modal con i collaborators deve spuntare il messaggio di errore oppure si può fare il submit anche se l'utente non ha aggiunto collaboratori? -->
                        <app-add-edit-collaborators [data]='data' (sendStatusToParent)='eventStatusFromChild($event)'>
                        </app-add-edit-collaborators>
                        <p class="subtitle-input">{{data?.subtitleInput}}</p>
                    </div>
                    <div class="form-group" *ngIf='data?.selector === "execution"'>
                        <app-add-edit-destinations [source]='source' [didSubmit]='submitted'
                                                   [namesInfo] = "{destination: 'Destinazione',
                                                        dropdown_placeholder: 'Seleziona una cartella'}"
                                                   (sendDestinationToParent)='handleDestination($event)'>
                        </app-add-edit-destinations>
                        <span class="destination-helper" *ngIf='data?.selector === "execution"'>
                            Una pratica deve essere in Workspace ›
                            project › cartella
                        </span>
                        <small class="text-error w-100 d-flex" *ngIf='validation'>La destinazione è obbligatoria. Per favore compila questo campo</small>
                    </div>
                    <div class="form-group" *ngIf="data?.selector === 'scenario'">
                        <app-add-methodology [data]="data" [didSubmit]='submitted' (sendStatusToParent)='handleMethodology($event)'>
                        </app-add-methodology>
                        <small class="text-error w-100 d-flex" *ngIf='validation'>Methology is mandatory. please choose one</small>
                    </div>
                </div>
                <div *ngIf="data?.selector === 'execution'" class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="privateMode" [(ngModel)]="isChecked"
                           [ngModelOptions]="{standalone: true}">
                    <label class="custom-control-label" for="privateMode">Crea la pratica in modalità privata</label>
                </div>
            </div>
            <div class="modal-footer pt-5">
                <button type="button" class="btn btn-outline-dark" (click)="onDelete(f)">Cancella</button>
                <button class="btn btn-default ml-3" type='submit'>Crea</button>
            </div>
        </form>
    </div>
